var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{attrs:{"action":_vm.uploadBaseUrl,"data":_vm.extraData,"on-success":_vm.afterUpload,"on-remove":_vm.removeFile,"limit":_vm.limit,"with-credentials":"","accept":_vm.accept,"file-list":_vm.getFileList}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }